module.exports = __webpack_public_path__ + "static/media/primary_arrow_up.50d42f06.svg";